
const PledgeHeader = () => {
  return (
    <div className="text-center">
      <span className="premium-subtitle text-accent">Support The Movement</span>
      <h2 className="premium-title mt-2 mb-6">
        Join Us Before December 2025 Launch
      </h2>
      <p className="premium-body max-w-3xl mx-auto mb-12">
        Your pledge secures promotional pricing and exclusive benefits that won't be available after launch. 
        Choose the level that matches your commitment to financial transparency.
      </p>
    </div>
  );
};

export default PledgeHeader;
